<template>
  <div class="coupon-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="发放时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div v-loading="loading">
      <!-- 核心指标 -->
      <el-row :gutter="16" class="stat-cards">
        <el-col :span="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-icon" style="background: #ecf5ff; color: #409eff;">
              <i class="el-icon-document"></i>
            </div>
            <div class="stat-meta">
              <div class="num">{{ stat.template_total || 0 }}</div>
              <div class="txt">券模板数</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-icon" style="background: #f0f9eb; color: #67c23a;">
              <i class="el-icon-s-promotion"></i>
            </div>
            <div class="stat-meta">
              <div class="num">{{ stat.send_batch || 0 }}</div>
              <div class="txt">发券批次数</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-icon" style="background: #fdf6ec; color: #e6a23c;">
              <i class="el-icon-s-ticket"></i>
            </div>
            <div class="stat-meta">
              <div class="num">{{ stat.coupon_total || 0 }}</div>
              <div class="txt">优惠券总张数</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-icon" style="background: #fef0f0; color: #f56c6c;">
              <i class="el-icon-coin"></i>
            </div>
            <div class="stat-meta">
              <div class="num price">¥{{ stat.used_amount || '0.00' }}</div>
              <div class="txt">已核销金额</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="16" class="stat-cards">
        <el-col :span="24">
          <el-card shadow="hover" class="stat-card usable-card">
            <div class="stat-icon" style="background: #f4ecff; color: #8e44ad;">
              <i class="el-icon-wallet"></i>
            </div>
            <div class="stat-meta">
              <div class="num price">¥{{ stat.usable_amount || '0.00' }}</div>
              <div class="txt">可用金额（未使用券面额合计，潜在可用）</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 各状态分布 -->
      <el-card class="table-card" shadow="never">
        <div slot="header" class="card-header">
          <span>券状态分布（张数 / 金额）</span>
        </div>
        <el-table :data="statusRows" border stripe style="width: 100%">
          <el-table-column label="状态" width="160">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.tagType">{{ scope.row.label }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="张数" width="160" align="center">
            <template slot-scope="scope">{{ scope.row.count }}</template>
          </el-table-column>
          <el-table-column label="面额合计（元）" align="center">
            <template slot-scope="scope">¥{{ scope.row.amount }}</template>
          </el-table-column>
          <el-table-column label="占总张数比例" width="260" align="center">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.percent" :color="scope.row.color" />
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import { couponStat } from '@/api/coupon'

export default {
  name: 'CouponStat',
  data () {
    return {
      loading: false,
      dateRange: [],
      stat: {
        template_total: 0,
        send_batch: 0,
        coupon_total: 0,
        status_count: {},
        status_amount: {},
        used_amount: '0.00',
        usable_amount: '0.00'
      }
    }
  },
  computed: {
    statusRows () {
      const count = this.stat.status_count || {}
      const amount = this.stat.status_amount || {}
      const total = Number(this.stat.coupon_total) || 0
      const defs = [
        { key: 'unused', label: '未使用', tagType: 'success', color: '#67c23a' },
        { key: 'locked', label: '已锁定', tagType: 'warning', color: '#e6a23c' },
        { key: 'used', label: '已使用', tagType: '', color: '#409eff' },
        { key: 'expired', label: '已过期', tagType: 'info', color: '#909399' },
        { key: 'invalid', label: '已失效', tagType: 'danger', color: '#f56c6c' }
      ]
      return defs.map(d => {
        const c = Number(count[d.key]) || 0
        return {
          ...d,
          count: c,
          amount: amount[d.key] || '0.00',
          percent: total > 0 ? Math.round((c / total) * 1000) / 10 : 0
        }
      })
    }
  },
  mounted () {
    this.fetchStat()
  },
  methods: {
    async fetchStat () {
      this.loading = true
      try {
        const params = {}
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_time = this.dateRange[0]
          params.end_time = this.dateRange[1]
        }
        const res = await couponStat(params)
        if (res && String(res.code) === '0') {
          this.stat = res.data || this.stat
        } else {
          this.$message.error(res && res.msg ? res.msg : '获取优惠券统计失败')
        }
      } catch (error) {
        console.error('获取优惠券统计失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.fetchStat()
    },

    handleReset () {
      this.dateRange = []
      this.fetchStat()
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 16px;

    .filter-form {
      margin-bottom: 0;
    }
  }
}

.stat-cards {
  margin-bottom: 16px;
}

.stat-card {
  ::v-deep .el-card__body {
    display: flex;
    align-items: center;
    padding: 18px 20px;
  }

  .stat-icon {
    width: 56px;
    height: 56px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin-right: 16px;
  }

  .stat-meta {
    .num {
      font-size: 26px;
      font-weight: 700;
      color: #303133;
      line-height: 1.2;

      &.price {
        color: #f56c6c;
      }
    }

    .txt {
      margin-top: 6px;
      color: #909399;
      font-size: 13px;
    }
  }
}

.usable-card {
  ::v-deep .el-card__body {
    justify-content: center;
  }
}

.table-card {
  .card-header {
    font-weight: 600;
  }
}
</style>
